import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toISODate, fmtDate } from "@/lib/format";
import { Calendar } from "@/components/ui/calendar";
import { Loading, ErrorBox } from "@/components/Common";

// Python weekday (Mon=0) from JS getDay (Sun=0)
const pyDay = (d) => (d.getDay() + 6) % 7;

export function SlotPicker({ config, slotsUrl, value, onChange, admin = false }) {
  const [slots, setSlots] = useState(null);
  const [err, setErr] = useState(null);
  const date = value?.date;

  useEffect(() => {
    if (!date) return;
    setSlots(null);
    setErr(null);
    api.get(slotsUrl(date)).then((r) => setSlots(r.data)).catch((e) => setErr(errMsg(e)));
  }, [date, slotsUrl]);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const maxDate = new Date(today);
  maxDate.setDate(maxDate.getDate() + (admin ? 365 : config.max_advance_days));
  const disabled = (d) =>
    d < today || d > maxDate || !config.working_days.includes(pyDay(d)) || config.unavailable_dates.includes(toISODate(d));

  return (
    <div className="grid gap-4 md:grid-cols-[auto_1fr]">
      <div className="rounded-md border border-border bg-card" data-testid="slot-calendar">
        <Calendar mode="single" selected={date ? new Date(`${date}T12:00:00`) : undefined}
          onSelect={(d) => d && onChange({ date: toISODate(d), start: null })} disabled={disabled} weekStartsOn={1} />
      </div>
      <div>
        {!date && <p className="text-sm text-muted-foreground">Choose a date to see available times.</p>}
        {date && (
          <>
            <p className="mb-2 text-sm font-medium">Available times on {fmtDate(date)} (UK time)</p>
            <ErrorBox error={err} />
            {!slots && !err && <Loading label="Checking availability…" />}
            {slots && !slots.length && <p className="text-sm text-muted-foreground" data-testid="no-slots">No times are available on this date. Please pick another day.</p>}
            <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
              {slots?.map((s) => (
                <button key={s.start} type="button" onClick={() => onChange({ date, start: s.start })} data-testid={`slot-${s.start}`}
                  aria-pressed={value?.start === s.start}
                  className={`rounded-md border px-2 py-2 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${value?.start === s.start ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card hover:bg-accent"}`}>
                  {s.start}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
